import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Modal from 'srcReact/components/common2/Modal'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Container from './Container'

function CreateFromExisting({ setHasFormErrors, attachedGroupId }) {
  const { t } = useTranslation()
  const {
    common: { isNative, isMobile }
  } = useSelector((state) => state)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }
  const hideModal = () => setIsModalOpen(false)

  return (
    <div className={styles.startFromContainer}>
      <button
        type='button'
        className={`${styles.btnStartFrom} ${isModalOpen && styles.btnStartFromActive}`}
        onClick={showModal}>
        {t('event.create.startFrom.title')}
        <Icon name='chevron-down24' size='large24' />
      </button>

      {isModalOpen && (
        <Modal
          title={t('event.create.startFrom.modalTitle')}
          className='select-draft-modal'
          customContentStyle={{
            paddingLeft: (isMobile || isNative) && '0',
            paddingRight: (isMobile || isNative) && '0'
          }}
          isOpen={isModalOpen}
          handleClose={hideModal}>
          <Container setHasFormErrors={setHasFormErrors} hideModal={hideModal} attachedGroupId={attachedGroupId} />
        </Modal>
      )}
    </div>
  )
}

export default CreateFromExisting
